import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'

import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import IntegrationAppAPI from 'api/integrationApp'
import ModalAlert from 'components/ModalAlert'
import InputPassword from 'components/forms/InputPassword'
import Button from 'components/forms/Button'
import InputLabel from 'components/forms/InputLabel'

/**
 * Verification token
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 *
 * @returns {React.Component}
 */
const VerificationToken = (props) => {
  const { app, setApp } = props

  const [inProgress, setInProgress] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const onCreateToken = useCallback(
    async () => {
      try {
        setShowModal(false)
        setInProgress(true)

        const token = await IntegrationAppAPI.createNewToken({ identifier: app._id })

        setApp(state => ({ ...state, token }))

        setInProgress(false)

        SaveToastNotification.ok({
          text: 'integration_app_token_create_ok'
        })
      } catch (error) {
        setInProgress(false)

        SaveToastNotification.error()
      }

    }, [app._id]
  )

  return (
    <div className='integrations-app-edit__verification-token'>
      <InputLabel
        title={I18n.t('integration_app_token')}
        actionButtons={
          <Button
            label={I18n.t('button_regenerate_title')}
            onClick={() => setShowModal(true)}
            disabled={inProgress}
            size='small'
          />
        }
      />
      <InputPassword
        value={app.token}
        disabled
      />
      {
        showModal
          ? (
            <ModalAlert
              isOpen={showModal}
              toggle={() => setShowModal(false)}
              text1={I18n.t('integration_app_new_token_title')}
              text2={I18n.t('integration_app_new_token_description')}
              event={() => onCreateToken()}
            />
          )
          : null
      }
    </div>
  )
}

export default VerificationToken
